import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "23",
  fill: "none",
  viewBox: "0 0 23 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.252 16.926c-.388.848-1.681 2.824-5.316 2.824a.69.69 0 0 1-.687-.687c0-3.635 1.976-4.928 2.824-5.316A.687.687 0 0 1 6.643 15c-.552.252-1.772 1.062-1.986 3.344C6.938 18.128 7.75 16.908 8 16.356a.689.689 0 0 1 1.252.57M19.736 4.551a1.375 1.375 0 0 0-1.289-1.289c-1.081-.064-3.844.035-6.136 2.327l-4.25 4.253a.688.688 0 0 1-.973-.972L9.37 6.586A.344.344 0 0 0 9.128 6h-2.24a1.37 1.37 0 0 0-.975.402l-2.948 2.95a1.375 1.375 0 0 0 .78 2.334l3.306.461 3.8 3.8.46 3.307a1.37 1.37 0 0 0 1.365 1.182 1.37 1.37 0 0 0 .971-.402l2.95-2.948a1.37 1.37 0 0 0 .402-.975v-2.24a.344.344 0 0 0-.587-.242l-2.283 2.282a.69.69 0 0 1-1.007-.036.705.705 0 0 1 .052-.954l4.234-4.234c2.294-2.293 2.392-5.056 2.328-6.137z"
    }, null, -1)
  ]))]))
}
export default { render: render }